import AuthLogo from "@assets/images/png/drsNewPlain.png";

const AuthHeader = ({ title }) => {
  return (
    <div className="flex items-center justify-center flex-col">
      <div className="text-center h-[100px] lg:h-[160px] w-full m-0 block">
        <img src={AuthLogo} alt="drs-logo" className="h-full w-auto object-contain"/>
      </div>
      <h2 className="font-extrabold font-openSansBold mt-5 text-lg lg:text-2xl mr-8 lg:mr-10">{title}</h2>
    </div>
  );
};

export default AuthHeader;